var map = {
	"./de/video-btn.png": "LNg8",
	"./en/video-btn.png": "fC3U",
	"./es/video-btn.png": "jUQT",
	"./fr/video-btn.png": "atuS",
	"./ja/video-btn.png": "Ck6k",
	"./ko/video-btn.png": "4z+8",
	"./pt/video-btn.png": "tp4v",
	"./ru/video-btn.png": "G0dt",
	"./tc/video-btn.png": "w73X",
	"./th/video-btn.png": "97R3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a3b2";